import { render, staticRenderFns } from "./translateTool.vue?vue&type=template&id=0f291e4a&scoped=true&"
import script from "./translateTool.vue?vue&type=script&lang=js&"
export * from "./translateTool.vue?vue&type=script&lang=js&"
import style0 from "./translateTool.vue?vue&type=style&index=0&id=0f291e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f291e4a",
  null
  
)

export default component.exports